import { getApiBaseUrl, getApiClient } from './serviceconfig';

const apiBaseUrl = getApiBaseUrl();

export async function getGeneralJournalNumber(cookies, plantId, journalDate) {
    const url = `${apiBaseUrl}/general_journals/general_journal_number/?plant_id=${plantId}&journal_date=${journalDate}`;
    return getApiClient(cookies).get(url).then((r) => r.data);
}

export async function getLedgerAccounts(cookies) {
    return getApiClient(cookies).get(`${apiBaseUrl}/general_journals/ledger_accounts/`).then((r) => r.data);
}

export async function getGeneralJournals(cookies, params = {}) {
    const query = new URLSearchParams(params).toString();
    return getApiClient(cookies).get(`${apiBaseUrl}/general_journals/${query ? `?${query}` : ''}`).then((r) => r.data);
}

export async function getGeneralJournalDetails(cookies, id) {
    return getApiClient(cookies).get(`${apiBaseUrl}/general_journals/${id}/`).then((r) => r.data);
}

export function createGeneralJournal(cookies, payload) {
    return getApiClient(cookies).post(`${apiBaseUrl}/general_journals/`, payload).then((r) => r.data);
}

export function updateGeneralJournal(cookies, id, payload) {
    return getApiClient(cookies).put(`${apiBaseUrl}/general_journals/${id}/`, payload).then((r) => r.data);
}

export function cancelGeneralJournal(cookies, id) {
    return getApiClient(cookies).patch(`${apiBaseUrl}/general_journals/${id}/`, {}).then((r) => r.data);
}

export function deleteGeneralJournal(cookies, id) {
    return getApiClient(cookies).delete(`${apiBaseUrl}/general_journals/${id}/`).then((r) => r.data);
}
